import { StagedAttachment, AttachmentType } from '@api/attachments/models/Attachment.model'
import StagedAttachmentEditor from '@components/common/StagedAttachmentEditor'
import useVendorAttachmentHook from './useVendorAttachmentHook'

interface StagedVendorAttachmentEditorProps {
  vendorID: string
  canEdit?: boolean
  stagedAttachments: StagedAttachment[]
  onStagedAttachmentsChange: (attachments: StagedAttachment[]) => void
  attachmentType?: AttachmentType
}

const StagedVendorAttachmentEditor = ({
  vendorID,
  canEdit = true,
  stagedAttachments,
  onStagedAttachmentsChange,
  attachmentType = 'Vendor',
}: StagedVendorAttachmentEditorProps) => {
  const entityConfig = {
    entityName: 'Vendor',
    entityIdLabel: 'Vendor ID',
    saveMessage: 'vendor',
  }

  return (
    <StagedAttachmentEditor<{ vendorID: string }>
      entityID={vendorID}
      entityConfig={entityConfig}
      canEdit={canEdit}
      stagedAttachments={stagedAttachments}
      onStagedAttachmentsChange={onStagedAttachmentsChange}
      attachmentType={attachmentType}
      useAttachmentHook={useVendorAttachmentHook}
      attachmentHookParamName="vendorID"
      maxAttachments={1}
    />
  )
}

export default StagedVendorAttachmentEditor